export const commercialisationTasksQueryKeys = {
  all: ["tasks"] as const,
  byId: (id: string) => [...commercialisationTasksQueryKeys.all, id] as const,
};

export default commercialisationTasksQueryKeys;
